export default {
  state: {
    tabActive: {},
    tabData: {}
  },
  getters: {
    tabActive: state => state.tabActive,
    tabData: state => state.tabData
  },
  mutations: {
    setTab: (
      state, 
      data = {
        tabActive: {},
        tabData: {}
      }
    ) => {
      let { tabActive, tabData } = data
      state.tabActive = tabActive
      state.tabData = tabData
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Tab/store.js